import { Module, VuexModule, MutationAction, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { PickupPoint } from '../models';
import { setPickupPoint, deletePickupPoint } from '../api';
import { initState } from '../stateinit';

@Module({
    namespaced: true,
    name: 'pickuppoint',
    store,
    dynamic: true,
})
class PickupPointModule extends VuexModule {
    public selectedPoint: PickupPoint = initState('selectedPickupPoint');

    @Mutation
    public setPickupPoint(pickupPoint: PickupPoint) {
        this.selectedPoint = pickupPoint;
    }

    @Action
    public async savePickupPoint(pickupPoint: PickupPoint) {
        this.setPickupPoint(pickupPoint);
        await setPickupPoint(pickupPoint.id, pickupPoint.data);
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    @Action
    public async deletePickupPoint() {
        this.setPickupPoint({id: '', data: {}});
        await deletePickupPoint();
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    }

    @Action
    public async openMapClickBtn() {
        return new Promise((resolve, reject) => {
            const elem = document.getElementById('btnShowMap') as HTMLElement;
            elem.style.display = 'none';
            setTimeout(() => {
              if (elem) {
                elem.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
              }
              resolve(true);
            }, 1000);
        });
    }
}

export default getModule(PickupPointModule);

